module.exports = __webpack_public_path__ + "img/icon_map_ymsh.cd6f6b48.png";